import script from "./BannerLista.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerLista.vue?vue&type=script&setup=true&lang=js"

import "./BannerLista.vue?vue&type=style&index=0&id=d888d2f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d888d2f2"]])

export default __exports__